export default __webpack_public_path__ + "static/media/redux.2f393050.svg";